module.exports = __webpack_public_path__ + "static/media/progress-chart-icon.3c12ddbe.svg";